<template>
  <v-card
      class="mx-auto"
      max-width="700px"
    >

      <v-card-title class="blue-bg">
        <span class="title font-weight-bold">Test de asociaciones implícitas -- Fundación Épica la Fura dels Baus</span>
      </v-card-title>

      <v-card-text class=" font-weight-light ">
        <v-row align="center" justify="center" >
          <v-col cols="12" class="text-center mt-4">
          </v-col>
          <v-col cols="12" class="text-center">
            <p class="title mt-2">Available Results</p>
          </v-col>
          <v-col>
                <v-data-table
                :headers="headers"
                :items="results"
                item-key="name"
                class="elevation-1"
                >
                <template v-slot:item.answers="{ item }">
                    <download-csv
                        :data= "item.answers"
                        :name="name(item)">
                        <a>Download Data</a>
                    </download-csv>
                </template>
                <!-- <template v-slot:top>
                    <v-text-field
                    v-model="search"
                    label="Search (UPPER CASE ONLY)"
                    class="mx-4"
                    ></v-text-field>
                </template> -->
                <!-- <template v-slot:body.append>
                    <tr>
                    <td></td>
                    <td>
                        <v-text-field
                        v-model="calories"
                        type="number"
                        label="Less than"
                        ></v-text-field>
                    </td>
                    <td colspan="4"></td>
                    </tr>
                </template> -->
                </v-data-table>
          </v-col>
        </v-row> 
      </v-card-text>

      <v-card-actions>
      </v-card-actions>
    </v-card>
</template>

<script>

import { mapState } from 'vuex'
import { mdiEmoticonCoolOutline } from '@mdi/js'

export default {
  name: 'CardResults',
  props: [],
  data: () => ({
    loader : true,
    results: [],
    
    }),
  mounted(){
    this.loader = true;
    this.$axios({
        method: 'post',
        //production
        url: 'https://misc.epicalab.com/iat-results/v1/graphql', 
        //development
        //url: 'http://35.205.180.84:8080/v1/graphql', 
        data: {
          query: `query MyQuery {
                    results {
                        id
                        userId
                        created_at
                        answers
                    }
                }`
        },
        headers: {  
                'Content-Type': 'application/json',
                'x-hasura-admin-secret': 'xlQsAzAk#Gah'
        }
      }).then( (response) => {
        // handle success
        this.results = response.data.data.results
        console.log(response);
      })
      .catch( (error) => {
        // handle error
        console.log(error);
      });
  },
  methods:{
      name(item){
          return `${item.userId}_data.csv`
      }
  },
  computed:{
    headers () {
        return [
            {
                text: 'Id',
                align: 'start',
                sortable: false,
                value: 'id',
            },
            {
                text: 'User ID',
                align: 'start',
                sortable: false,
                value: 'userId',
            },
            {
                text: 'Date',
                align: 'start',
                sortable: false,
                value: 'created_at',
            },
            {
                text: 'Answers',
                align: 'start',
                sortable: false,
                value: 'answers',
            }
            
        ]
    }

  }
};
</script>

<style>

</style>

